import { findIndex, isUndefined, cloneDeep } from "lodash";
import { IControlSchema, RuleOptions } from "../Controls";
import { I18NString } from "../../libs/helpers/Utils";
import {RulesStrategy} from "./RulesStrategy";
import AndConditionStrategy from "./RulesStrategy/AndConditionStrategy";
import OrConditionStrategy from "./RulesStrategy/OrConditionStrategy";
import { TableColum } from "../../libs/controls/Grid/interfaces";

interface ISectionSchema {
	id: string;
	title: I18NString;
	controls: Array<IControlSchema>;
	$$timestamp?: number;
}

class RuleManagers {

	/**
	 * Запускает полную проверку всей Schema формы
	 * @param sections
	 * @param values
	 */
	public run(sections: Array<ISectionSchema>, values: Array<{ controlId: string; value: any }>): void {
		// console.log(123)
		// TODO: replace all while,for,for(of,in)
		// eslint-disable-next-line no-restricted-syntax
		for (const section of sections) {
			const { controls } = section;
			section.controls = this.round(controls, values);
		}
	}

	/**
	 * Проверяет конкретный ctrl
	 * @param ctrl
	 * @param values
	 */
	private static checkControl = (ctrl: IControlSchema | TableColum, values: Array<{ controlId: string; value: any }>): IControlSchema | TableColum | null => {
		let result = cloneDeep(ctrl);
		const rulesStrategy = new RulesStrategy(values);

		//TODO В будущем надо объединить requiredRule и visibleRule в одно свойство. Чтоб запихивать в условие лишь конструкцию, отвечающую за выполнение
		// Какой либо операции с полями
		//Условная обязательность поля
		if(result?.requiredRule) {
			switch (result.requiredRule.type.toUpperCase()) {
				case "AND": {
					rulesStrategy.setStrategy(new AndConditionStrategy());
					break;
				}
				case "OR": {
					rulesStrategy.setStrategy(new OrConditionStrategy());
					break;
				}
				default: {
					throw new Error('Not defined rule type OR/AND');
				}
			}
			result = {...result, required: rulesStrategy.validateField(result.requiredRule.rules)};
		}

		//Видимость в последнюю очередь, если элемент не видимый, то вернет null
		if(result?.visibleRule) {
			switch (result.visibleRule.type.toUpperCase()) {
				case "AND": {
					rulesStrategy.setStrategy(new AndConditionStrategy());
					break;
				}
				case "OR": {
					rulesStrategy.setStrategy(new OrConditionStrategy());
					break;
				}
				default: {
					throw new Error('Not defined rule type OR/AND');
				}
			}
			const rules = !Array.isArray(result.visibleRule.rules) ? [result.visibleRule.rules] : [...result.visibleRule.rules];
			return rulesStrategy.validateField(rules) ? result : null;
		} else {
			// В последнюю очередь, для обратной совместимости
			// TODO будущем все что ниже надо просто удалить
			if(result?.rule) {
				const rules = !Array.isArray(result.rule) ? [result.rule] : [...result.rule];
				switch (result?.rule_operation?.toUpperCase()) {
					case "AND": {
						rulesStrategy.setStrategy(new AndConditionStrategy());
						break;
					}
					case "OR": {
						rulesStrategy.setStrategy(new OrConditionStrategy());
						break;
					}
					default: {
						rulesStrategy.setStrategy(new AndConditionStrategy());
					}
				}
				return rulesStrategy.validateField(rules) ? result : null;
			}
		}

		return result;
	}

	/**
	 * Проверяет все controls в форме, и возвращает результат controls которые нужно отрендерить нужным образом
	 * @param controls
	 * @param values
	 * @private
	 */
	public round(
		controls: Array<IControlSchema> | Array<TableColum>,
		values: Array<{ controlId: string; value: any }>,
		debug?: boolean
	): Array<any> {
		const result: Array<any> = [];

		// eslint-disable-next-line no-restricted-syntax
		for (const ctrl of controls) {
			//Делаем копию, чтоб не происходили мутации
			let visibleControl: IControlSchema | TableColum | null = cloneDeep(ctrl);
			let columnResults = null;

			//Если у элемента есть columns то это Grid или Group, и тут входим в рекурсию
			// @ts-ignore
			if (visibleControl?.type?.toUpperCase() !== "GROUP" && visibleControl.columns && visibleControl.columns.length > 0) {
				// @ts-ignore
				columnResults = this.round(visibleControl.columns, values);
			}

			//В конце цикла добавляем элемент в массив, с дочерними элементами, или без них
			visibleControl = RuleManagers.checkControl(visibleControl, values);
			if(visibleControl) {
				result.push(
					columnResults ? {
						...visibleControl,
						columns: columnResults
					} : visibleControl
				);
			}
		}

		if(debug) {
			console.log('controls', controls);
			console.log('values', values);
			console.log('result', result);
		}

		return result;
	}
}

export default RuleManagers;
